import { useEffect, useState } from 'react';
import styled from 'styled-components';

import { VFlex } from '@/components/base';

import Typo from '../Typography/Typo';

type Props = {
  values: RangeValue;
  onChange: (values: RangeValue) => void;
  placeholder?: {
    min?: string;
    max?: string;
  };
};

const RangeInput = ({ values, onChange, placeholder }: Props) => {
  const [minValue, setMinValue] = useState<number | null>(values.min ?? null);
  const [maxValue, setMaxValue] = useState<number | null>(values.max ?? null);

  useEffect(() => {
    setMinValue(values.min ?? null);
    setMaxValue(values.max ?? null);
  }, [values.max, values.min]);

  const handleMinChange = (value: number | null) => {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    setMinValue(numberValue);
  };

  const handleMaxChange = (value: number | null) => {
    const numberValue = typeof value === 'string' ? parseFloat(value) : value;
    setMaxValue(numberValue);
  };

  return (
    <div className="flex items-end gap-4 p-4 min-w-[280px]">
      <VFlex g={8} a="center">
        <Label className="text-xs text-gray-700 font-medium -translate-x-2">
          Min
        </Label>
        <input
          className="border border-gray-300 rounded-md p-1.5 text-center text-sm"
          type="number"
          value={minValue ?? ''}
          onChange={(e) => handleMinChange(e.target.valueAsNumber)}
          placeholder={placeholder?.min || 'Enter minimum value'}
          min={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.currentTarget.blur();
            }
          }}
          onBlur={() => {
            onChange({
              min: minValue ?? undefined,
              max: maxValue ?? undefined,
            });
          }}
        />
      </VFlex>
      <Typo type="label3" className="text-gray-700 mb-2">
        ~
      </Typo>
      <VFlex g={8} a="center">
        <Label className="text-xs text-gray-700 font-medium -translate-x-2">
          Max
        </Label>
        <input
          className="border border-gray-300 rounded-md p-1.5 text-center text-sm"
          type="number"
          value={maxValue ?? ''}
          onChange={(e) => handleMaxChange(e.target.valueAsNumber)}
          placeholder={placeholder?.max || 'Enter maximum value'}
          min={0}
          onKeyDown={(e) => {
            if (e.key === 'Enter') {
              e.currentTarget.blur();
            }
          }}
          onBlur={() => {
            onChange({
              min: minValue ?? undefined,
              max: maxValue ?? undefined,
            });
          }}
        />
      </VFlex>
    </div>
  );
};

const Label = styled.div`
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.gray700};
`;

export default RangeInput;
